"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[340],{

/***/ 84333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Me": () => (/* binding */ TravelNote),
/* harmony export */   "Nj": () => (/* binding */ PopularCountry),
/* harmony export */   "P5": () => (/* binding */ BgText),
/* harmony export */   "QQ": () => (/* binding */ PopularCountryItem),
/* harmony export */   "Q_": () => (/* binding */ CountryImg),
/* harmony export */   "S_": () => (/* binding */ DiscountingNote),
/* harmony export */   "TR": () => (/* binding */ TripUpcoming),
/* harmony export */   "Vr": () => (/* binding */ UpcomingTripStyle),
/* harmony export */   "cM": () => (/* binding */ UpcomingTripTag),
/* harmony export */   "fK": () => (/* binding */ TravellingToStyleWrap),
/* harmony export */   "in": () => (/* binding */ OtherCountyBtn),
/* harmony export */   "s0": () => (/* binding */ TravellingToStyle),
/* harmony export */   "xZ": () => (/* binding */ CountryNameTxt)
/* harmony export */ });
/* unused harmony exports TravelDetailsStyle, ButtonWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54927);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);




const TravelDetailsStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelDetailsStyle",
  componentId: "sc-1eenbn7-0"
})(["background:#ffffff;padding:30px;"]);
const TravellingToStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyle",
  componentId: "sc-1eenbn7-1"
})(["background:#ffffff;padding:30px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;position:relative;", "{padding:5px;margin:-5px;}@media ", "{padding:16px;margin-bottom:36px;}"], _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .TagsStyle */ .EN, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const PopularCountry = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountry",
  componentId: "sc-1eenbn7-2"
})(["display:flex;flex-wrap:wrap;gap:8px;label{left:0 !important;position:absolute;bottom:8px;z-index:1;}@media ", "{margin-bottom:16px;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:14px;width:calc(100vw - 64px);min-height:178px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const PopularCountryItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountryItem",
  componentId: "sc-1eenbn7-3"
})(["background:linear-gradient(228.82deg,#43c6ac 2.05%,#191654 93.35%);border:1px solid #fff;border-radius:6px;z-index:1;padding:8px;overflow:hidden;width:80px;height:82px;position:relative;flex-shrink:0;cursor:pointer;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);", " > div{cursor:pointer;}picture{height:82px;}@media ", "{width:unset;height:82px;picture{height:82px;}}"], p => p.listSelected && `
        border: 1px solid #008cff;
        `, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const OtherCountyBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__OtherCountyBtn",
  componentId: "sc-1eenbn7-4"
})(["display:flex;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);flex-direction:column;gap:8px;width:80px;height:82px;background:#fff;border-radius:6px;padding:8px;cursor:pointer;@media ", "{width:unset;height:82px;gap:6px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const CountryImg = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__CountryImg",
  componentId: "sc-1eenbn7-5"
})(["position:absolute;top:0px;left:0px;bottom:0;z-index:-1;max-width:100%;max-height:100%;width:100%;picture{width:100%;}picture img{width:80px;height:80px;}:after{content:\"\";position:absolute;border-radius:0px 0px 6px 6px;background:linear-gradient( 180deg,rgba(106,106,106,0) 0%,rgba(0,0,0,0.7) 100% );width:100%;height:32px;bottom:1px;left:0;}@media ", "{picture img{width:100%;height:82px;}}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravelNote = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelNote",
  componentId: "sc-1eenbn7-6"
})(["background:linear-gradient( 85.23deg,rgba(67,225,168,0.5) 0%,rgba(33,147,147,0.5) 100% );border-radius:8px 8px 0px 0px;padding:8px 78px;margin:0 auto;color:#fff;font-size:16px;width:550px;text-align:center;em{font-weight:600;color:#8beecd;font-style:normal;}@media ", "{width:92%;padding:12px;font-size:12px;text-align:center;padding-bottom:24px;margin-bottom:-12px;}@media ", "{", "}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.desktop, p => p.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? `
        background: linear-gradient(45deg, #43E1A8 0%, #219393 100%);
    ` : p.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI ? `background: #18A160;` : ``);
const DiscountingNote = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__DiscountingNote",
  componentId: "sc-1eenbn7-7"
})(["border-radius:8px 8px 0px 0px;padding:8px 0px 8px 16px;margin:0 auto;color:", ";width:550px;display:flex;align-items:center;@media ", "{width:92%;padding:12px;padding-bottom:24px;margin-bottom:-12px;background:#e4fbf4;}@media ", "{background:#e4fbf4;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText5 */ .rS.greyText5, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.desktop);
const TravellingToStyleWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyleWrap",
  componentId: "sc-1eenbn7-8"
})([""]);
const UpcomingTripStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripStyle",
  componentId: "sc-1eenbn7-9"
})(["display:flex;align-items:center;justify-content:space-between;background:#ffffff;border-radius:6px;padding:24px 12px 12px;margin-bottom:16px;position:relative;cursor:pointer;", " ", "{width:24px;height:24px;}&::before{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border:1px solid transparent;background:", ";-webkit-mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border-radius:6px;}"], p => p.selected && `
    background: #EAF5FF;
    border: 1px solid #008CFF;
  `, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .AnchorTagStyle */ .C2, _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.purpleGradient */ .rS.purpleGradient);
const UpcomingTripTag = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripTag",
  componentId: "sc-1eenbn7-10"
})(["background:", ";padding:2px 6px;border-radius:6px 0px 6px 0px;width:fit-content;position:absolute;top:0;left:0;display:flex;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.purpleGradient */ .rS.purpleGradient);
const BgText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__BgText",
  componentId: "sc-1eenbn7-11"
})(["background:radial-gradient( 59.37% 231.91% at 3.11% 23.44%,rgba(255,255,255,0.24) 0%,rgba(255,255,255,0.144) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-style:normal;font-weight:700;font-size:56px;line-height:64px;position:absolute;top:-59px;right:6px;"]);
const TripUpcoming = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TripUpcoming",
  componentId: "sc-1eenbn7-12"
})(["background:linear-gradient( 91.22deg,#9c005e 1.88%,rgba(22,20,60,0.2) 100% );padding:2px 8px;color:#fff;position:absolute;bottom:24px;left:-10px;white-space:nowrap;width:100%;font-weight:400;font-size:9px;line-height:11px;text-transform:uppercase;text-wrap:wrap;"]);
const CountryNameTxt = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__CountryNameTxt",
  componentId: "sc-1eenbn7-13"
})(["display:-webkit-box;color:#ffffff;font-size:12px;-webkit-line-clamp:2;font-weight:700;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;white-space:normal;width:75%;text-shadow:0px 0px 8px rgba(0,0,0,0.8);"]);
const ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__ButtonWrapper",
  componentId: "sc-1eenbn7-14"
})(["position:fixed;bottom:0;background:#fff;padding:16px;left:0;right:0;width:100%;z-index:1;"]);

/***/ }),

/***/ 62915:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TravelDetails_TravellingToShimmer)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(98892);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidgetShimmer.tsx





const TravellingToWidgetShimmer = ({}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    "data-test-id": "TravellingToWidgetShimmer-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetShimmerStyle */.fF, {
      "data-test-id": "TravellingToWidgetShimmer-TravelDateWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetShimmerStyle */.Mf, {
      "data-test-id": "TravellingToWidgetShimmer-TravellerCountWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellingToWidgetShimmer = (TravellingToWidgetShimmer);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(84333);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx







const TravellingToShimmer = () => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingToShimmer-TravellingToStyleWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      "data-test-id": "TravellingToShimmer-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion3 */.AO, {
        height: "22px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingToShimmer-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        margin: "0 0 16px",
        width: "100%",
        height: "28px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        margin: "0 0 8px",
        width: "80%",
        height: "16px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        margin: device == "sm" ? "0 0 20px" : "",
        flexWrap: "wrap",
        gap: "8px",
        "data-test-id": "TravellingToShimmer-FlexComp",
        children: Array.from({
          length: 5
        }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "89px",
          height: "79px",
          "data-test-id": `TravellingToShimmer-ShimmerVersion2-${index}`
        }, index))
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionDividers */.LV, {
        margin: "30px -30px 30px",
        xs: true,
        "data-test-id": "TravellingToShimmer-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidgetShimmer, {
        "data-test-id": "TravellingToShimmer-TravellingToWidgetShimmer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion3 */.AO, {
        width: "100%",
        height: "44px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })]
    })]
  });
};

/* harmony default export */ const TravelDetails_TravellingToShimmer = (TravellingToShimmer);

/***/ }),

/***/ 98892:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": () => (/* binding */ TravellerCountWigetStyle),
/* harmony export */   "Jp": () => (/* binding */ TravelDateWigetStyle),
/* harmony export */   "Mf": () => (/* binding */ TravellerCountWigetShimmerStyle),
/* harmony export */   "N": () => (/* binding */ ChevStateWrap),
/* harmony export */   "ZN": () => (/* binding */ CounterBtn),
/* harmony export */   "ZP": () => (/* binding */ DateSeparator),
/* harmony export */   "bF": () => (/* binding */ TravellingToWidgetStyle),
/* harmony export */   "fF": () => (/* binding */ TravelDateWigetShimmerStyle),
/* harmony export */   "vg": () => (/* binding */ CounterWrap)
/* harmony export */ });
/* unused harmony exports TravelPurposeWigetStyle, WidgetList, ListItem, EmptySpace, ChevWrap, BtnWrap */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54927);



const TravellingToWidgetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellingToWidgetStyle",
  componentId: "sc-1vav6o1-0"
})(["display:flex;margin-bottom:24px;position:relative;@media ", "{flex-direction:column;", "{height:300px;}}", "{position:absolute;top:-20px;left:-20px;background:#005756;bottom:auto;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .CommonModalDwebStyle */ .E5, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .ToastStyle */ .jf);
const TravelPurposeWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelPurposeWigetStyle",
  componentId: "sc-1vav6o1-1"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;flex:2;cursor:pointer;position:relative;border-left:none;"]);
const TravellerCountWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetStyle",
  componentId: "sc-1vav6o1-2"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;flex:1.1;position:relative;display:flex;justify-content:space-between;gap:8px;align-items:center;@media ", "{border-radius:0 0 8px 8px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravellerCountWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(TravellerCountWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetShimmerStyle",
  componentId: "sc-1vav6o1-3"
})(["display:flex;gap:20px;align-items:end;"]);
const TravelDateWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetStyle",
  componentId: "sc-1vav6o1-4"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;border-right:none;flex:1;cursor:pointer;position:relative;@media ", "{border-right:1px solid #e7e7e7;border-bottom:none;border-radius:8px 8px 0 0;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravelDateWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(TravelDateWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetShimmerStyle",
  componentId: "sc-1vav6o1-5"
})(["display:flex;gap:20px;align-items:end;"]);
/* istanbul ignore next */

const WidgetList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__WidgetList",
  componentId: "sc-1vav6o1-6"
})(["background:#ffffff;box-shadow:0px 1px 6px rgba(0,0,0,0.2);border-radius:6px;width:", ";height:213px;overflow-y:scroll;position:absolute;top:30px;right:0;z-index:1;", ""], p => p.width ? p.width : "111px", p => p.travelCount && `
left:250px;
`);
const ListItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ListItem",
  componentId: "sc-1vav6o1-7"
})(["padding:8px 16px;border-bottom:1px solid #ebebeb;cursor:pointer;display:flex;align-items:center;", " @media ", "{padding:12px 24px;display:flex;align-items:center;justify-content:center;&:last-child{margin-bottom:60px;}}"], p => p.selected && `
    ${_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs}{
        color:#008CFF;
        font-weight:700;
    }
    `, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const EmptySpace = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__EmptySpace",
  componentId: "sc-1vav6o1-8"
})(["width:100%;height:60px;padding:18px;"]);
const ChevWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevWrap",
  componentId: "sc-1vav6o1-9"
})(["margin-left:auto;"]);
const DateSeparator = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "TravellingToWidgetstyle__DateSeparator",
  componentId: "sc-1vav6o1-10"
})(["flex-shrink:0;"]);
const ChevStateWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevStateWrap",
  componentId: "sc-1vav6o1-11"
})(["transition:0.5s ease-in;", ""], p => p.open && `
transform:rotate(180deg);
`);
const BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__BtnWrap",
  componentId: "sc-1vav6o1-12"
})(["background:var(--base-white,#fff);box-shadow:0px -1px 8px 0px rgba(0,0,0,0.25);padding:16px;position:fixed;bottom:0;left:0px;right:0px;"]);
const CounterWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CounterWrap",
  componentId: "sc-1vav6o1-13"
})(["border-radius:4px;background:#fff;box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);padding:0px 8px;display:flex;gap:14px;align-items:center;width:fit-content;height:40px;button{background:transparent;cursor:pointer;display:flex;padding:0;}span{word-break:unset;}"]);
const CounterBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "TravellingToWidgetstyle__CounterBtn",
  componentId: "sc-1vav6o1-14"
})(["", ""], p => p.isDiabled && `
pointer-events:none;
opacity:0.5;
`);

/***/ }),

/***/ 51066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Breadcrumb": () => (/* reexport */ Breadcrumb/* default */.Z),
  "ClaimYourInsurance": () => (/* reexport */ ClaimYourInsurance/* default */.Z),
  "DomesticTrip": () => (/* reexport */ DomesticTrip/* default */.Z),
  "ExclusiveOffers": () => (/* reexport */ ExclusiveOffers/* default */.Z),
  "InsuranceStats": () => (/* reexport */ InsuranceStats/* default */.Z),
  "InterlinkingBlock": () => (/* reexport */ InterlinkingBlock/* default */.Z),
  "LandingFaq": () => (/* reexport */ LandingFaq/* default */.Z),
  "LandingFooter": () => (/* reexport */ LandingFooter/* default */.Z),
  "LandingTestimonials": () => (/* reexport */ LandingTestimonials/* default */.Z),
  "PersuasionBannerInsurance": () => (/* reexport */ PersuasionBannerInsurance/* default */.Z),
  "SafenSecureTrav": () => (/* reexport */ SafenSecureTrav/* default */.Z),
  "SecureTravOffer": () => (/* reexport */ SecureTravOffer/* default */.Z),
  "SelectCountryCodeModal": () => (/* reexport */ SelectCountryCodeModal/* default */.Z),
  "SelectCountryModal": () => (/* reexport */ SelectCountryModal/* default */.Z),
  "SelectCountryModalSheet": () => (/* reexport */ SelectCountryModalSheet/* default */.Z),
  "SeoContent": () => (/* reexport */ SeoContent_SeoContent),
  "TravellingTo": () => (/* reexport */ TravelDetails_TravellingTo),
  "TravellingToShimmer": () => (/* reexport */ TravellingToShimmer/* default */.Z),
  "TravellingToWidget": () => (/* reexport */ TravellingToWidget_TravellingToWidget),
  "WhatsCovered": () => (/* reexport */ WhatsCovered_WhatsCovered),
  "WhyBuyTravIns": () => (/* reexport */ WhyBuyTravIns_WhyBuyTravIns)
});

// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/index.tsx + 2 modules
var Breadcrumb = __webpack_require__(62145);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.tsx + 2 modules
var ClaimYourInsurance = __webpack_require__(75767);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTrip.tsx + 1 modules
var DomesticTrip = __webpack_require__(10135);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.tsx + 2 modules
var ExclusiveOffers = __webpack_require__(87380);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.tsx + 1 modules
var InsuranceStats = __webpack_require__(30845);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/index.tsx + 2 modules
var InterlinkingBlock = __webpack_require__(20190);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.tsx + 1 modules
var LandingFaq = __webpack_require__(69004);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.tsx + 1 modules
var LandingFooter = __webpack_require__(81086);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.tsx + 1 modules
var LandingTestimonials = __webpack_require__(37580);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBannerInsurance.tsx + 1 modules
var PersuasionBannerInsurance = __webpack_require__(85662);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.tsx + 2 modules
var SafenSecureTrav = __webpack_require__(20381);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.tsx + 1 modules
var SecureTravOffer = __webpack_require__(8431);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryCodeModal.tsx
var SelectCountryCodeModal = __webpack_require__(79607);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.tsx + 2 modules
var SelectCountryModal = __webpack_require__(57593);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModalSheet.tsx
var SelectCountryModalSheet = __webpack_require__(79377);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SeoContent/SeoContent.style.ts



const SeoContentStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SeoContentstyle__SeoContentStyle",
  componentId: "sc-1ipkwsi-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}ul{list-style:initial;padding-left:30px;}h1,h2,h3,h4,h5,h6,p,ul{margin:1em 0;}@media ", "{padding:0 16px;", "}"], p => p.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    background: #EFF3F8;
    padding-bottom:80px;
    `, components/* H2TagStyle */.FI, isomorphic_utils_src.deviceType.mobile, isomorphic_utils_src.deviceType.mobile, p => p.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    background: #fff;
    padding-top:16px;
    `);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SeoContent/SeoContent.tsx





const SeoContent = ({
  seoContent
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContentStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "SeoContent-SeoContentStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(src/* InnerContentWrap */.IY, {
      dangerouslySetInnerHTML: {
        __html: seoContent
      },
      "data-test-id": "SeoContent-InnerContentWrap"
    })
  });
};

/* harmony default export */ const SeoContent_SeoContent = (SeoContent);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.tsx + 3 modules
var DescriptionModal = __webpack_require__(69452);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 4 modules
var utils = __webpack_require__(64264);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(84333);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/PopularCountryCompV2.tsx









const PopularCountryComp = ({
  popCountry,
  handleShowOtherCountry,
  otherCountryTxt,
  handlePopularCountrySelect,
  setIsSelectedError,
  setCountrySelectToastMsg
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const isCheckedHandler = (0,react.useCallback)(data => {
    return data?.isSelected;
  }, [popCountry]);
  const handleErrorToast = (0,utils/* debounce */.Ds)(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelect = item => {
    if (item.isDisabled) {
      const isExclusiveCountrySelected = popCountry?.find(item => item.isExclusiveSelection && item.isSelected);

      if (isExclusiveCountrySelected && !item?.isExclusiveSelection && item.isDisabled) {
        setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
        handleErrorToast();
      } else if (item?.isExclusiveSelection && !isExclusiveCountrySelected && item.isDisabled) {
        setCountrySelectToastMsg("India cannot be chosen for International Travel");
        handleErrorToast();
      } else if (item.isDisabled) {
        setIsSelectedError(true);
        handleErrorToast();
      }
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountry */.Nj, {
    "data-test-id": "PopularCountryComp-PopularCountry",
    children: [popCountry && popCountry.slice(0, 5).map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountryItem */.QQ, {
        listSelected: isCheckedHandler(item),
        onClick: () => handleCountrySelect(item),
        "data-test-id": `PopularCountryComp-PopularCountryItem-${index}`,
        children: [index !== popCountry.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CheckButton */.nt, {
          isDisabled: item.isDisabled,
          isChecked: item.isDisabled ? true : isCheckedHandler(item),
          "data-test-id": "PopularCountryComp-CheckButton",
          children: [!item.img && item.name && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* BgText */.P5, {
            "data-test-id": "PopularCountryComp-BgText",
            children: item?.code
          }), item.upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TripUpcoming */.TR, {
            "data-test-id": "PopularCountryComp-TripUpcoming",
            children: "TRIP UPCOMING"
          }), item?.name && !item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item?.name
          }), item?.name && item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name + item.subtitle,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item?.name + " " + item.subtitle
          })]
        }), item?.img && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryImg */.Q_, {
          "data-test-id": "PopularCountryComp-CountryImg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: device == "sm" ? "100%" : "80px",
            height: device == "lg" ? "80px" : "82px",
            src: item.img,
            loading: "eager",
            "data-test-id": "PopularCountryComp-ImageComponent"
          })
        })]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* OtherCountyBtn */["in"], {
      onClick: handleShowOtherCountry,
      "data-test-id": "PopularCountryComp-OtherCountyBtn",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
        loading: "eager",
        "data-test-id": "PopularCountryComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.blueText */.rS.blueText,
        "data-test-id": "PopularCountryComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: otherCountryTxt,
          "data-test-id": "PopularCountryComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const PopularCountryCompV2 = (PopularCountryComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/UpcomingTrips.tsx










const analytics = (0,insurance/* getAnalytics */.I)();

const UpcomingTrips = ({
  country,
  travelDuration,
  travellerNum,
  travellerTitle,
  handleUpcomingTripClick
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isUpcomingTripSelected,
    1: setIsUpcomingTripSelected
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const isUpcomingTrip = queryParams.get("isUpcomingTrip");

    if (isUpcomingTrip) {
      setIsUpcomingTripSelected(true);
    }

    analytics?.trackLandingEvents({
      actionType: "upcoming_trips_shown"
    });
  }, []);

  const showFormattedDate = date => {
    if (date) {
      const dateValue = (0,utils/* convertUnixToDate */.P9)(date);
      return (0,utils/* formatDate */.p6)(dateValue, isomorphic_utils_src.DATE_FORMATS["DD MMM YY"]);
    }

    return "";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* UpcomingTripStyle */.Vr, {
    selected: isUpcomingTripSelected,
    onClick: handleUpcomingTripClick,
    "data-test-id": "UpcomingTrips-UpcomingTripStyle",
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* UpcomingTripTag */.cM, {
      "data-test-id": "UpcomingTrips-UpcomingTripTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xxs",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: "UPCOMING TRIP"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      flexDirection: "column",
      "data-test-id": "UpcomingTrips-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
        fontWeight: "bold",
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: country,
          "data-test-id": "UpcomingTrips-FormattedText"
        }), "\xA0"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
        fontSize: "xs",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [` ${showFormattedDate(travelDuration?.startDate)} - ${showFormattedDate(travelDuration?.endDate)}`, " ", "| ", travellerNum, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travellerTitle,
          "data-test-id": "UpcomingTrips-FormattedText"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
      "data-test-id": "UpcomingTrips-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
        width: "16px",
        height: "16px",
        "data-test-id": "UpcomingTrips-ImageTag"
      })
    })]
  });
};

/* harmony default export */ const TravelDetails_UpcomingTrips = (UpcomingTrips);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(91908);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var utility_src = __webpack_require__(97427);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts + 1 modules
var xdmEvents = __webpack_require__(46535);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingTo.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















const TravellingTo_analytics = (0,insurance/* getAnalytics */.I)();

const TravellingTo = ({
  travellingToSection,
  upcomingTrip,
  calendarDatesLimit,
  travelSearchBanner,
  btnDisabledState = true,
  nextPageRoute,
  countryCodes,
  setLoginModal
}) => {
  const buttonRef = (0,react.useRef)(null);
  const device = (0,src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  const {
    otherCountryTxt,
    travelNote,
    travDateTitle,
    travCountTitle,
    travPurpTitle,
    travelPurposeTxt,
    popularCountryTxt,
    travelBtnTxt,
    travelSearchForm
  } = travellingToSection || {};
  const {
    label,
    error_message,
    countrySelectErrMsg,
    placeHolder,
    value
  } = travelSearchForm.regionCountryList;
  const {
    0: popularCountries,
    1: setPopularCountries
  } = (0,react.useState)([]);
  const {
    0: countryData,
    1: setCountryData
  } = (0,react.useState)([]);
  const {
    0: showOtherCountry,
    1: setOtherCountry
  } = (0,react.useState)(false);
  const {
    0: countValue,
    1: setCountValue
  } = (0,react.useState)(0);
  const {
    0: calenderValue,
    1: setCalenderValue
  } = (0,react.useState)();
  const {
    0: showCountry,
    1: setShowCountry
  } = (0,react.useState)([]);
  const {
    0: isCountryError,
    1: setIsCountryError
  } = (0,react.useState)(false);
  const {
    0: descriptionTxt,
    1: setDescriptionTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: descTitle,
    1: setDescTitle
  } = (0,react.useState)("");
  const {
    0: segments,
    1: setSegments
  } = (0,react.useState)([]);
  const {
    0: segmentSelected,
    1: setSegmentSelected
  } = (0,react.useState)({});
  const {
    0: isSegmentModalShown,
    1: setIsSegmentModalShown
  } = (0,react.useState)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const {
    0: showLoginModal,
    1: setShowLoginModal
  } = (0,react.useState)(false);
  const {
    0: nextPageError,
    1: setNextPageError
  } = (0,react.useState)(); //set the default selected segement

  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment");
    const segments = travelSearchForm?.segments?.value;

    if (segments) {
      const segment = segments.find(item => item.id === segParam || !segParam && item.isSelected);

      if (segment) {
        setSegmentSelected(segment);
        (0,utils/* replaceHistory */.df)("segment", segment.id);
      }
    }
  }, []); //set the travelSerachForm.segments to segments

  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment");

    if (travelSearchForm?.segments?.value) {
      if (segParam) {
        handleSegementSelect(segParam);
      } else {
        setSegments(travelSearchForm?.segments?.value);
      }
    }
  }, [travelSearchForm?.segments]);
  (0,react.useEffect)(() => {
    if (travelSearchForm?.segments) {
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "special_segments_shown"
      } //"click"
      );
      (0,XDMAnalytics.trackComponentView)({
        name: "special_segments_shown",
        type: "card"
      });
    }
  }, [travelSearchForm?.segments]);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = queryParams.get("countries") || countryCodes;
    let selectedCountryCodes;

    if (selectedCountries) {
      selectedCountryCodes = selectedCountries?.split(",");
    } else if (upcomingTrip?.countryCode) {
      selectedCountryCodes = upcomingTrip?.countryCode;
      (0,utils/* replaceHistory */.df)("countries", upcomingTrip?.countryCode);
    }

    let totalCountryData = value?.map(data => {
      if (selectedCountryCodes?.includes(data.code)) {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, data);
    });
    const isExclusiveCountrySelected = totalCountryData?.find(item => item.isExclusiveSelection && item.isSelected);
    totalCountryData = totalCountryData?.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (totalCountryData.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedRegionCodes = totalCountryData?.filter(data => data.isSelected && data.type === "REGION")?.map(data => data.code);
    selectedRegionCodes?.map(code => {
      totalCountryData = totalCountryData?.map(country => {
        if (country.regionCodes && country.regionCodes.includes(code)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    setCountryData(totalCountryData);
    let popularCountryData = totalCountryData?.filter(country => country.isSelected || country.isPopular) ?? [];
    popularCountryData = [...popularCountryData?.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData?.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)];
    setShowCountry([...popularCountryData]);
    setPopularCountries([...popularCountryData]);
  }, [value, upcomingTrip, travelSearchForm.segments]);
  (0,react.useEffect)(() => {
    const button = buttonRef.current;
    let viewportMargin = 16;
    let searchBarOffset = 60;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;
      const isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        const scrollPosition = offsetTop - window.innerHeight + rect.height + viewportMargin + searchBarOffset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    }
  }, [showCountry]);

  const populateTravelDetails = (countryCodes, startDate, endDate, travellers) => {
    if (countryCodes) {
      (0,utils/* replaceHistory */.df)("countries", countryCodes);
    }

    if (startDate) {
      (0,utils/* replaceHistory */.df)("startDate", startDate);
    }

    if (endDate) {
      (0,utils/* replaceHistory */.df)("endDate", endDate);
    }

    if (travellers) {
      (0,utils/* replaceHistory */.df)("travellers", travellers);
    }
  };

  const handleUpcomingTripClick = () => {
    (0,utils/* replaceHistory */.df)("isUpcomingTrip", "true");
    (0,utility_src/* removeSessionStorageItem */.lD)(isomorphic_utils_src.STORAGE_KEYS.TRAVELLER_DETAILS);
    TravellingTo_analytics?.trackLandingEvents({
      actionType: "upcoming_trips_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_clicked"
      }
    });
    const {
      countryCode,
      travelDuration,
      travellerNum
    } = upcomingTrip || {};
    const selectedCountry = countryData?.find(country => country.code === countryCode);
    populateTravelDetails(selectedCountry?.code, travelDuration?.startDate?.toString(), travelDuration?.endDate?.toString(), travellerNum?.toString());

    if (nextPageRoute) {
      navigation/* navigationActionsSeo.navigateToPageByRouteName */.Ro.navigateToPageByRouteName(`${nextPageRoute}&isUpcomingTrip=true`);
    } else {
      const data = {
        startDate: travelDuration?.startDate?.toString(),
        endDate: travelDuration?.endDate?.toString(),
        travellers: travellerNum?.toString?.(),
        countries: [countryCode],
        isUpcomingTrip: true
      };
      navigation/* navigationActionsSeo.navigateToListing */.Ro.navigateToListing(data);
    }
  };

  const handleShowOtherCountry = () => {
    if (!showOtherCountry) {
      let countryDataArr = countryData?.map(country => {
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: false
        });
      });
      popularCountries.map(data => {
        countryDataArr = countryDataArr?.map(country => {
          if (country.code === data.code) {
            return _objectSpread(_objectSpread({}, country), {}, {
              isSelected: data.isSelected
            });
          }

          return _objectSpread({}, country);
        });
      });
      const isExclusiveCountrySelected = countryDataArr.find(item => item.isExclusiveSelection && item.isSelected);
      countryDataArr = countryDataArr?.map(country => {
        if (isExclusiveCountrySelected) {
          return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
            isSelected: false,
            isDisabled: true
          });
        } else if (countryDataArr.some(item => item.isSelected)) {
          return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          }) : _objectSpread({}, country);
        }

        return _objectSpread({}, country);
      });
      const selectedRegionCodes = countryDataArr.filter(data => data.isSelected && data.type === "REGION").map(data => data.code);
      selectedRegionCodes?.map(code => {
        countryDataArr = countryDataArr.map(country => {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return _objectSpread(_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return _objectSpread({}, country);
        });
      });
      setCountryData(countryDataArr);
    }

    setOtherCountry(!showOtherCountry);
  };

  const handleDescriptionModal = country => {
    const clickedTime = (0,utility_src/* getSessionStorageItem */.St)("clickedTime") ? (0,utility_src/* getSessionStorageItem */.St)("clickedTime") : {};
    const currentTime = new Date().getTime();
    const code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      (0,utility_src/* setSessionStorageItem */.D9)("clickedTime", _objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  const handlePopularCountrySelect = code => {
    setIsCountryError(false);
    let popularCountryArr = popularCountries?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return _objectSpread({}, country);
        }

        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }

        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = popularCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    popularCountryArr = popularCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        }) : _objectSpread({}, country);
      } else if (popularCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedPopRegionCodes = popularCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedPopRegionCodes.map(item => {
      popularCountryArr = popularCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    const selectedCountries = popularCountryArr.filter(country => country.isSelected && !country.isDisabled);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "sco:popular_country_selected"
      }
    }, {
      countries: selectedCountries
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    const countries = popularCountryArr.filter(data => data.isSelected && !data.isDisabled).map(data => data.code).join(",");

    if (countries) {
      (0,utils/* replaceHistory */.df)("countries", countries);
    } else {
      (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    }
  };

  const handleSegementSelect = segmentId => {
    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map(item => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,utils/* replaceHistory */.df)("segment", item.id);
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  const handleSegmentClick = segmentId => {
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "sco:segment_clicked"
      }
    }, {
      journeyType: segmentId?.toString().toLowerCase() || ""
    });

    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map(item => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,utils/* replaceHistory */.df)("segment", item.id);
          TravellingTo_analytics?.trackLandingEvents({
            actionType: item.config.clickEventName
          } //"click"
          );
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  let toastTimeout = null;

  const toggleSegmentModal = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");

    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && segmentSelected?.id === "STUDENT") {
      setCountrySelectToastMsg("We do not have domestic student plans, please select another country to see student plans");
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      segmentSelected?.modal && setIsSegmentModalShown(true);
    }
  };

  const onSubmit = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const isUpcomingTrip = searchParams.get("isUpcomingTrip");
    let countryCodes = countries?.split(","); // If no countries in URL, check the state for selected countries

    if (!countryCodes) {
      const selectedCountriesFromState = showCountry?.filter(country => country.isSelected && !country.isDisabled)?.map(country => country.code);

      if (selectedCountriesFromState?.length > 0) {
        countryCodes = selectedCountriesFromState; // Update URL with selected countries from state

        (0,utils/* replaceHistory */.df)("countries", selectedCountriesFromState.join(",")); // Clear any existing country error since we found selected countries

        setIsCountryError(false);
      }
    }

    if (!countryCodes || countryCodes.length === 0) {
      setIsCountryError(true);
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "error_shown",
        payload: error_message
      } //"click"
      );
      (0,xdmEvents/* errorTrackEvent */.t1)({
        error_details_list: [{
          message: error_message,
          source: "country_select",
          severity: "P3"
        }]
      });
      return; // Don't proceed with API call if no countries are selected
    } else {
      // Clear error if we have countries
      setIsCountryError(false);
    }

    if (isUpcomingTrip) {
      (0,utils/* replaceHistoryRemoveParams */._A)("isUpcomingTrip");
      searchParams.delete("isUpcomingTrip");
      (0,utility_src/* removeSessionStorageItem */.lD)(isomorphic_utils_src.STORAGE_KEYS.TRAVELLER_DETAILS);
    }

    (0,utils/* replaceHistory */.df)("segment", segmentSelected?.id);

    if (calenderValue && countValue && countryCodes?.length) {
      const selectedPopCountries = (popularCountries ?? []).filter(country => countryCodes?.includes(country.code)).map(item => item.name).join("|");
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "popular_country_selected",
        payload: selectedPopCountries
      } //"click"
      );
      const queryParams = Object.fromEntries(searchParams.entries());

      const params = _objectSpread(_objectSpread({}, queryParams), {}, {
        startDate: (0,utils/* convertDateToUnix */.cJ)(calenderValue.from).toString(),
        endDate: calenderValue.to ? (0,utils/* convertDateToUnix */.cJ)(calenderValue.to).toString() : searchParams.get("endDate"),
        travellers: countValue,
        countries: countryCodes,
        segment: segmentSelected?.id
      });

      TravellingTo_analytics?.trackLandingEvents({
        actionType: "explore_plan_click"
      } //"click"
      );
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "explore_plan_click"
        }
      });
      const partner = (0,utils/* getPartnerOnClientSide */.et)();
      const requestData = {
        query: {
          source: "seo"
        },
        partner,
        userSearchIntent: {
          country: countryCodes,
          departureDateTime: (0,utils/* convertDateToUnix */.cJ)(calenderValue.from),
          arrivalDateTime: calenderValue.to ? (0,utils/* convertDateToUnix */.cJ)(calenderValue.to) : Number(searchParams.get("endDate")),
          numberOfTravellers: countValue,
          segment: segmentSelected?.id
        }
      };

      try {
        const response = await (0,api/* getNextPageRouteDetails */.$P)(requestData);
        const {
          responseStatus,
          nextPageRouteConfig
        } = response;

        if (responseStatus === isomorphic_utils_src.RESPONSE_STATUS.SUCCESS) {
          navigation/* navigationActionsSeo.navigateToPageByRouteName */.Ro.navigateToPageByRouteName(`${nextPageRouteConfig?.route}`);
        }
      } catch (error) {
        console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
          error: error?.response
        });

        if (error?.response?.status === 401) {
          const domain = partner === isomorphic_utils_src.PARTNER.GI ? ".goibibo.com" : ".makemytrip.com";

          if ((0,utils/* getCookieByName */.A7)("next_page_req")) {
            document.cookie = `next_page_req=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/`;
          }

          document.cookie = `next_page_req= ${JSON.stringify(requestData)}; expires=${new Date(Date.now() + 15 * 60 * 1000).toUTCString()}; domain=${domain}; path=/`;

          if (device === "sm" && partner === isomorphic_utils_src.PARTNER.MMT) {
            const host = window.location.host;
            const req = {
              url: window.location.pathname + window.location.search
            };
            document.cookie = "loginActionDetails=" + JSON.stringify(`https://${host}/insurance/next-page`) + ";domain=.makemytrip.com;path=/";
            window.location.href = "https://www.makemytrip.com/pwa/hlp/v3/login";
          }

          setLoginModal?.("LOGIN");
        } else {
          setNextPageError(error?.response);
        }
      }
    }
  };

  const isExclusiveCountrySelected = countryData.find(item => item.isExclusiveSelection && item.isSelected);

  if (nextPageError && true) {
    throw new utility_src/* ClientError */.XF(nextPageError);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingTo-TravellingToStyleWrap",
    children: [travelSearchBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* DiscountingNote */.S_, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-DiscountingNote",
      children: [travelSearchBanner?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        width: "24px",
        height: "24px",
        src: travelSearchBanner?.icon,
        style: {
          animation: "rotate 2s linear infinite"
        },
        loading: "eager"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: device === "sm" ? "column" : "row",
        margin: "0px 0px 0px 4px",
        gap: device === "lg" ? "4px" : "0px",
        "data-test-id": "TravellingTo-FlexComp",
        children: [travelSearchBanner?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travelSearchBanner?.title,
          baseStyle: {
            fontWeight: "bold",
            fontSize: device === "lg" ? "16px" : "12px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        }), travelSearchBanner?.description && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travelSearchBanner?.description,
          baseStyle: {
            fontWeight: "regular",
            fontSize: device === "lg" ? "14px" : "12px",
            marginTop: device === "lg" ? "2px" : "0px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: travelNote,
        "data-test-id": "TravellingTo-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingTo-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "TravellingTo-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: label,
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        margin: "0px 0px 20px 0px",
        "data-test-id": "TravellingTo-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: placeHolder,
          baseStyle: {
            color: "#717171"
          },
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_UpcomingTrips, {
        country: upcomingTrip?.country,
        countryCode: upcomingTrip?.countryCode,
        travelDuration: upcomingTrip?.travelDuration,
        travellerNum: upcomingTrip?.travellerNum,
        travellerTitle: upcomingTrip?.travellerTitle,
        handleUpcomingTripClick: handleUpcomingTripClick,
        "data-test-id": "TravellingTo-UpcomingTrips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        color: Global/* theme.greyText7 */.rS.greyText7,
        fontWeight: "bold",
        fontSize: "xs",
        margin: "2px 0 8px",
        "data-test-id": "TravellingTo-SpanTag",
        children: popularCountryTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: "Popular Destination",
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PopularCountryCompV2, {
        otherCountryTxt: otherCountryTxt,
        handleShowOtherCountry: handleShowOtherCountry,
        popCountry: showCountry,
        setIsSelectedError: setIsSelectedError,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        handlePopularCountrySelect: handlePopularCountrySelect,
        "data-test-id": "TravellingTo-PopularCountryComp"
      }), isCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        color: Global/* theme.redText2 */.rS.redText2,
        fontSize: "xs",
        margin: device === "sm" ? "0 0 8px" : "8px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: error_message
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionDividers */.LV, {
        margin: "14px -30px 14px",
        backgroundColor: "#FFFFFF",
        xs: true,
        "data-test-id": "TravellingTo-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidget, {
        travelPurposeTxt: travelPurposeTxt,
        travCountTitle: travCountTitle,
        travPurpTitle: travPurpTitle,
        travDateTitle: travDateTitle,
        btnDisabledState: btnDisabledState,
        setCountValue: setCountValue,
        calendarDatesLimit: calendarDatesLimit,
        setCalenderValue: setCalenderValue,
        upcomingTravellerNum: upcomingTrip?.travellerNum,
        upcomingFromDate: upcomingTrip?.travelDuration?.startDate,
        upcomingToDate: upcomingTrip?.travelDuration?.endDate,
        calendarConfig: isExclusiveCountrySelected?.config?.calendar || segmentSelected?.config || calendarDatesLimit,
        "data-test-id": "TravellingTo-TravellingToWidget"
      }), travelSearchForm?.segments && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        margin: "0 0 24px",
        gap: "8px",
        flexDirection: "column",
        "data-test-id": "TravellingTo-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "xs",
          fontWeight: "bold",
          textTransform: "uppercase",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "TravellingTo-ParaTag",
          children: travelSearchForm?.segments?.label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tags */.$G, {
          handleClickTab: handleSegmentClick,
          data: travelSearchForm?.segments?.value,
          "data-test-id": "TravellingTo-Tags"
        })]
      }), isSegmentModalShown && segmentSelected && segmentSelected?.modal && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CommonModalDweb */.Eq, {
        customIcon: segmentSelected?.modal?.icon,
        customTitle: segmentSelected?.modal?.title,
        handleClick: () => {
          setIsSegmentModalShown(false);
        },
        nonClipHeading: true,
        "data-test-id": "TravellingTo-CommonModalDweb",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "md",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "0 0 36px",
          "data-test-id": "TravellingTo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: segmentSelected?.modal?.description,
            "data-test-id": "TravellingTo-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
            handleClick: () => {
              setIsSegmentModalShown(false);
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: segmentSelected?.modal?.secondaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
            handleClick: () => {
              setIsSegmentModalShown(false);
              onSubmit();
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: segmentSelected?.modal?.primaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          })]
        })]
      }), travelBtnTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        buttonref: buttonRef,
        customWidth: "100%",
        customTitle: travelBtnTxt,
        onClick: segmentSelected?.modal && travelSearchForm?.segments ? toggleSegmentModal : onSubmit,
        "data-test-id": "TravellingTo-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        color: Global/* theme.greyText */.rS.greyText,
        margin: "16px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: travelSearchForm?.disclaimer
      }), showOtherCountry && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal/* default */.Z, {
        countryData: countryData,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        showCountry: showCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModal"
      }), showOtherCountry && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalSheet/* default */.Z, {
        countryData: countryData,
        showCountry: showCountry,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalSheet"
      }), descriptionTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionModal/* default */.Z, {
        handleDescriptionModal: () => setDescriptionTxt(""),
        value: descriptionTxt,
        title: descTitle,
        "data-test-id": "TravellingTo-DescriptionModal"
      }), isSelectedError && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      }), isSelectedError && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "10px",
        "data-test-id": "TravellingTo-WebToast"
      }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectToastMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      })]
    })]
  });
};

/* harmony default export */ const TravelDetails_TravellingTo = (TravellingTo);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx + 1 modules
var TravellingToShimmer = __webpack_require__(62915);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(51046);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(98892);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravelDateWiget.tsx








const TravelDateWiget = ({
  showTravDate,
  handleTravDate,
  ref,
  travDateTitle,
  startDate,
  endDate
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetStyle */.Jp, {
    ref: ref,
    onClick: handleTravDate,
    "data-test-id": "TravelDateWiget-TravelDateWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      gap: "8px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [travDateTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        textTransform: "uppercase",
        color: showTravDate ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravelDateWiget-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travDateTitle,
          "data-test-id": "TravelDateWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
        open: showTravDate,
        "data-test-id": "TravelDateWiget-ChevStateWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
          "data-test-id": "TravelDateWiget-BlueChev"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      gap: "4px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [startDate?.getDate(), " \xA0", startDate ? isomorphic_utils_src.MONTHS[parseInt(startDate?.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", startDate?.getFullYear().toString().slice(-2)]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: startDate && isomorphic_utils_src.LONG_WEEK_DAYS[startDate.getDay()]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* DateSeparator */.ZP, {
        "data-test-id": "TravelDateWiget-DateSeparator",
        children: "-to-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [endDate ? endDate.getDate() : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? 1 : startDate.getDate() + 1 : null, "\xA0", endDate ? isomorphic_utils_src.MONTHS[parseInt(endDate.getMonth().toString().slice(-2))] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? isomorphic_utils_src.MONTHS[parseInt((startDate.getMonth() + 1).toString().slice(-2))] : isomorphic_utils_src.MONTHS[parseInt(startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", endDate ? endDate.getFullYear().toString().slice(-2) : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? startDate.getMonth() === 11 ? (startDate.getFullYear() + 1).toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : null]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: endDate ? isomorphic_utils_src.LONG_WEEK_DAYS[endDate.getDay()] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? isomorphic_utils_src.LONG_WEEK_DAYS[new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDay()] : isomorphic_utils_src.LONG_WEEK_DAYS[startDate.getDay()] : null
        })]
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravelDateWiget = (TravelDateWiget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellerCounterWiget.tsx






const TravellerCounterWiget = ({
  showTravCount,
  handleCaptureCountIncr,
  handleCaptureCountDecr,
  captureCount,
  travCountTitle,
  travCountSubtitle
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetStyle */.Dq, {
    "data-test-id": "TravellerCounterWiget-TravellerCountWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        textTransform: "uppercase",
        color: showTravCount ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travCountTitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        color: Global/* theme.greyText6 */.rS.greyText6,
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountSubtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travCountSubtitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* CounterWrap */.vg, {
      "data-test-id": "TravellerCounterWiget-CounterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == 1,
        onClick: handleCaptureCountDecr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
            fill: "#008CFF"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: captureCount && captureCount <= 9 ? "0" + captureCount : captureCount
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == 20,
        onClick: handleCaptureCountIncr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
            fill: "#008CFF"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellerCounterWiget = (TravellerCounterWiget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.tsx












const TravellingToWidget_analytics = (0,insurance/* getAnalytics */.I)();

const TravellingToWidget = ({
  travelPurposeTxt,
  travCountTitle,
  travPurpTitle,
  travDateTitle,
  btnDisabledState,
  setCountValue,
  calendarDatesLimit,
  setCalenderValue,
  calenderRef,
  upcomingTravellerNum,
  upcomingFromDate,
  upcomingToDate,
  calendarConfig
}) => {
  const {
    endDateErrorMessage,
    insPurchaseDateLimitInDays,
    //total no. of allowed days from start date (for end date)
    insPurchaseEndDateLimitInDays,
    //max no. of allowed days from start date (for end date)
    insPurchaseStartDateLimitInDays,
    //max no. of allowed days from current date (for start date)
    insPurchaseStartDateMinLimitInDays,
    //min no. of days from current date (for start date)
    startDateErrorMessage,
    insPurchaseEndDateMinLimitInDays
  } = (calendarConfig ? calendarConfig : calendarDatesLimit) || {};
  const from = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateMinLimitInDays);
  const to = (0,utils/* addDaysToDate */.Xz)(from || new Date(), insPurchaseEndDateMinLimitInDays || 0);
  const defaultSelected = {
    from,
    to
  };
  const maxEndDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseDateLimitInDays);
  const device = (0,src/* useBreakpointV2 */.bU)();
  const ref = (0,react.useRef)(null);
  const divRefs = (0,react.useRef)([]);
  const {
    0: captureCount,
    1: setCaptureCount
  } = (0,react.useState)(1);
  const {
    0: dateTab,
    1: setDateTab
  } = (0,react.useState)(0);
  const {
    0: range,
    1: setRange
  } = (0,react.useState)(defaultSelected);
  const {
    0: showToast,
    1: setShowToast
  } = (0,react.useState)(false);
  const {
    0: toastMessage,
    1: setToastMessage
  } = (0,react.useState)("");
  const {
    0: startDate,
    1: setStartDate
  } = (0,react.useState)(new Date());
  const {
    0: endDate,
    1: setEndDate
  } = (0,react.useState)();
  const {
    0: focusedIndex,
    1: setFocusedIndex
  } = (0,react.useState)(-1);
  const prevFocusedIndexRef = (0,react.useRef)(focusedIndex);

  const handleClickOutside = event => {
    if (ref?.current && !ref?.current?.contains(event.target)) {
      setFocusedIndex(-1);
      setShowToast(false);
    }
  };

  const addTravellerNumber = travNumber => {
    if (travNumber > isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS || travNumber < isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCaptureCount(isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);
      (0,XDMAnalytics.updateSearchContext)({
        travellers: isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
      });
      (0,utils/* replaceHistory */.df)("travellers", isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS.toString());
    } else {
      setCaptureCount(travNumber);
      (0,XDMAnalytics.updateSearchContext)({
        travellers: travNumber
      });
      (0,utils/* replaceHistory */.df)("travellers", travNumber.toString());
    }
  };

  const addTravellerDates = (travStartDate, travEndDate) => {
    const tempFromDate = (0,utils/* convertUnixToDate */.P9)(travStartDate);
    const tempToDate = (0,utils/* convertUnixToDate */.P9)(travEndDate);
    (0,utils/* replaceHistory */.df)("startDate", travStartDate.toString());
    (0,utils/* replaceHistory */.df)("endDate", travEndDate.toString());
    (0,XDMAnalytics.updateSearchContext)({
      fromDateTime: travStartDate,
      toDateTime: travEndDate
    });
    setRange({
      from: tempFromDate,
      to: tempToDate
    });
  };

  (0,react.useEffect)(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  (0,react.useEffect)(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const trav = queryParameters.get("travellers");
    const fromDate = queryParameters.get("startDate");
    const toDate = queryParameters.get("endDate");

    if (trav && !Number.isNaN(parseInt(trav))) {
      addTravellerNumber(parseInt(trav));
    } else if (upcomingTravellerNum) {
      addTravellerNumber(upcomingTravellerNum);
    }

    if (fromDate && toDate) {
      addTravellerDates(parseInt(fromDate), parseInt(toDate));
    } else if (upcomingFromDate && upcomingToDate) {
      addTravellerDates(upcomingFromDate, upcomingToDate);
    } else {
      (0,XDMAnalytics.updateSearchContext)({
        fromDateTime: defaultSelected.from?.getTime() ? defaultSelected.from.getTime() / 1000 : undefined,
        toDateTime: defaultSelected.to?.getTime() ? defaultSelected.to.getTime() / 1000 : undefined
      });
    }
  }, []);
  (0,react.useEffect)(() => {
    setEndDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  }, []);
  (0,react.useEffect)(() => {
    if (captureCount >= isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCountValue(captureCount);
    }
  }, [captureCount]);
  (0,react.useEffect)(() => {
    if (range) {
      setCalenderValue(range);
    }
  }, [range]);
  (0,react.useEffect)(() => {
    const datePickerElement = document.getElementById("datePickerContainer");

    if (datePickerElement) {
      const rect = datePickerElement.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (prevFocusedIndexRef.current === 0 && focusedIndex !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (focusedIndex === 0 && !isInView) {
        const offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }

    prevFocusedIndexRef.current = focusedIndex;
  }, [focusedIndex]);
  (0,react.useEffect)(() => {
    if (range?.to === undefined && range?.from) {
      let tempToDate = new Date(range?.from);
      tempToDate.setDate(tempToDate.getDate() + 1);
      (0,utils/* replaceHistory */.df)("endDate", (0,utils/* convertDateToUnix */.cJ)(tempToDate).toString());
    }
  }, [range?.from]);

  const handleClick = index => {
    if (index === focusedIndex) {
      setFocusedIndex(-1);
      setShowToast(false);
    } else {
      setFocusedIndex(index);
    }
  };

  const handleDayClick = selectedDate => {
    if (dateTab === 0) {
      const maxStartDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateLimitInDays);

      if (maxStartDate && maxStartDate < selectedDate) {
        // alert(startDateErrorMessage);
        setShowToast(true);
        setToastMessage(startDateErrorMessage);
      } else if (range?.from && range?.to) {
        setRange({
          from: selectedDate,
          to: undefined
        });
        (0,utils/* replaceHistory */.df)("startDate", (0,utils/* convertDateToUnix */.cJ)(selectedDate).toString());
        setDateTab(1);
        setShowToast(false);
      }
    } else if (dateTab === 1) {
      if (range?.from) {
        const fromDate = new Date(range?.from);
        const maxEndDate = (0,utils/* addDaysToDate */.Xz)(fromDate, calendarConfig?.insPurchaseEndDateLimitInDays);

        if (range?.from > selectedDate) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          setShowToast(false);
        } else if (maxEndDate && maxEndDate <= selectedDate) {
          setShowToast(true);
          setToastMessage(endDateErrorMessage);
        } else {
          setRange({
            from: range?.from,
            to: selectedDate
          });
          setShowToast(false);
          setDateTab(0);

          if (device == "lg") {
            setFocusedIndex(1);
          }

          (0,utils/* replaceHistory */.df)("endDate", (0,utils/* convertDateToUnix */.cJ)(selectedDate).toString());
          TravellingToWidget_analytics?.trackLandingEvents({
            actionType: "travel_date_selected",
            payload: {
              departure: range.from?.toLocaleDateString("en-GB")?.replace(/\//gi, ":"),
              arrival: range.to?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
            }
          } //"click"
          );
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "travel_date_selected"
            }
          }, {
            fromDateTime: (0,utils/* convertDateToUnix */.cJ)(range?.from),
            toDateTime: (0,utils/* convertDateToUnix */.cJ)(selectedDate)
          });
        }
      }
    }
  };

  const handleCaptureCountIncr = () => {
    captureCount < isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? setCaptureCount(captureCount + 1) : setCaptureCount(isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);
    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount < isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? captureCount + 1 : isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS
    });
    (0,utils/* replaceHistory */.df)("travellers", (captureCount + 1).toString());
  };

  const handleCaptureCountDecr = () => {
    captureCount > isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? setCaptureCount(captureCount - 1) : setCaptureCount(isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS); // if (device == 'lg') {
    //     setFocusedIndex(2);
    // }

    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount > isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? captureCount - 1 : isomorphic_utils_src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
    });
    (0,utils/* replaceHistory */.df)("travellers", (captureCount - 1).toString());
  };

  const handleSubmit = (chkIn, chkOut) => {
    chkIn && setStartDate(chkIn);
    chkOut && setEndDate(chkOut);
    TravellingToWidget_analytics?.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: chkIn?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || "",
        arrival: chkOut?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
      }
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "travel_date_selected"
      }
    }, {
      fromDateTime: chkIn ? (0,utils/* convertDateToUnix */.cJ)(chkIn) : 0,
      toDateTime: chkOut ? (0,utils/* convertDateToUnix */.cJ)(chkOut) : 0
    });
    setFocusedIndex(-1);
    setShowToast(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    ref: device == "lg" ? ref : null,
    "data-test-id": "TravellingToWidget-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravelDateWiget, {
      ref: divRefs.current[0],
      showTravDate: focusedIndex == 0,
      handleTravDate: () => handleClick(0),
      travDateTitle: travDateTitle,
      startDate: range?.from,
      endDate: range?.to,
      "data-test-id": "TravellingToWidget-TravelDateWiget"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWiget // ref={divRefs.current[1]}
    // showTravCount={focusedIndex == 1}
    , {
      captureCount: captureCount,
      travCountTitle: travCountTitle,
      handleCaptureCountIncr: handleCaptureCountIncr,
      handleCaptureCountDecr: handleCaptureCountDecr,
      "data-test-id": "TravellingToWidget-TravellerCounterWiget"
    }), focusedIndex == 0 && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* DatePickerComp */.X9, {
      startDateLabel: "Start Date",
      endDateLabel: "End Date",
      handleDayClick: handleDayClick,
      dateTab: dateTab,
      selected: range,
      from: range?.from,
      to: range?.to,
      maxEndDate: maxEndDate,
      toastMessage: toastMessage,
      showToast: showToast,
      "data-test-id": "TravellingToWidget-DatePickerComp"
    }), focusedIndex == 0 && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ReactPortalComp */.hK, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RangeDatePicker */.$m, {
        calendarFooter: true,
        calendarHeader: true,
        onBackPress: () => handleClick(0),
        onSubmitButtonPress: handleSubmit,
        range: true,
        calenderRef: calenderRef,
        from: range?.from,
        to: range?.to,
        toastMessage: toastMessage,
        showToast: showToast,
        selected: range,
        handleDayClick: handleDayClick,
        maxEndDate: maxEndDate,
        "data-test-id": "TravellingToWidget-RangeDatePicker"
      })
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellingToWidget = (TravellingToWidget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhatsCovered/WhatsCovered.style.ts




const WhatsCoveredStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhatsCoveredstyle__WhatsCoveredStyle",
  componentId: "sc-1fouhoy-0"
})(["background:#fff;width:100%;", "{font-weight:900;}", " @media ", "{padding:0 16px;", "{> ", "{overflow-y:auto;-webkit-overflow-scrolling:touch;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;}}}"], components/* H2TagStyle */.FI, p => p.pageTheme === isomorphic_utils_src.PARTNER.MMT && `
    ${components/* H4TagStyle */.sz}{
        font-size:24px;
        font-weight:900;
    }
    `, isomorphic_utils_src.deviceType.mobile, src/* InnerContentWrap */.IY, components/* FlexCompStyle */.lL);
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhatsCoveredstyle__BenefitItem",
  componentId: "sc-1fouhoy-1"
})(["flex:1;@media ", "{width:230px;flex-shrink:0;flex:none;}"], isomorphic_utils_src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhatsCovered/WhatsCovered.tsx








const WhatsCovered = ({
  data,
  title,
  info
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsCoveredStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "WhatsCovered-WhatsCoveredStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(src/* InnerContentWrap */.IY, {
      "data-test-id": "WhatsCovered-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
        "data-test-id": "WhatsCovered-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        "data-test-id": "WhatsCovered-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        fontSize: device == "lg" ? "large" : "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "0 0 66px",
        "data-test-id": "WhatsCovered-ParaTag",
        children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: info,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? data?.length === 2 ? "50px" : "82px" : "24px",
        padding: "0 0 15px 0",
        "data-test-id": "WhatsCovered-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
            "data-test-id": `WhatsCovered-BenefitItem-${index}`,
            children: [item.cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: device == "lg" ? "164px" : "80px",
              height: device == "lg" ? "164px" : "80px",
              src: item.cardImg,
              "data-test-id": "WhatsCovered-ImageComponent"
            }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H4Tag */.j9, {
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-H4Tag",
              children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ParaTag */.dZ, {
              fontSize: "large",
              fontWeight: "black",
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-ParaTag",
              children: [" ", item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
              fontSize: device == "lg" ? "large" : "sm",
              color: device == "lg" ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
              "data-test-id": "WhatsCovered-ParaTag",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.info,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const WhatsCovered_WhatsCovered = (WhatsCovered);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhyBuyTravIns/WhyBuyTravIns.style.ts



const WhyBuyTravInsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyTravInsStyle",
  componentId: "dnzmib-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}@media ", "{padding:0 16px;", "}"], p => p.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    background: #EFF3F8;
    padding-bottom:80px;
    `, components/* H2TagStyle */.FI, isomorphic_utils_src.deviceType.mobile, isomorphic_utils_src.deviceType.mobile, p => p.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    background: #fff;
    padding-top:16px;
    `);
const WhyFeatListWrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyFeatListWrap",
  componentId: "dnzmib-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:16px;flex-shrink:0;@media ", "{width:100%;grid-template-columns:repeat(1,1fr);}img{margin-top:4px;}"], isomorphic_utils_src.deviceType.mobile);
const WhyBuyItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyItem",
  componentId: "dnzmib-2"
})(["display:flex;gap:8px;padding:16px;background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;width:300px;flex-shrink:0;font-size:18px;line-height:25px;svg{flex-shrink:0;}@media ", "{width:100%;box-shadow:none;}"], isomorphic_utils_src.deviceType.mobile);
const ShieldWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuyTravInsstyle__ShieldWrap",
  componentId: "dnzmib-3"
})(["position:absolute;right:-60px;z-index:-1;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhyBuyTravIns/WhyBuyTravIns.tsx








const WhyBuyTravIns = ({
  title,
  info,
  data
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuyTravInsStyle, {
    "data-test-id": "WhyBuyTravIns-WhyBuyTravInsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(src/* InnerContentWrap */.IY, {
      "data-test-id": "WhyBuyTravIns-InnerContentWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA // flexWrap="wrap"
      , {
        flexDirection: device == "lg" ? "row" : "column",
        alignItems: "center",
        gap: device == "lg" ? "74px" : "24px",
        "data-test-id": "WhyBuyTravIns-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
            margin: "0 0 60px",
            "data-test-id": "WhyBuyTravIns-H2Tag",
            children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            margin: "0 0 20px",
            "data-test-id": "WhyBuyTravIns-H5Tag",
            children: [" ", title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: device == "lg" ? "large" : "sm",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "WhyBuyTravIns-ParaTag",
            children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: info,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyFeatListWrap, {
          "data-test-id": "WhyBuyTravIns-WhyFeatListWrap",
          children: data && data.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuyItem, {
              "data-test-id": `WhyBuyTravIns-WhyBuyItem-${index}`,
              children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                src: item.icon,
                height: "24",
                width: "24",
                "data-test-id": "WhyBuyTravIns-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                "data-test-id": "WhyBuyTravIns-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item?.info,
                  "data-test-id": "WhyBuyTravIns-FormattedText"
                })
              })]
            }, index);
          })
        }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(ShieldWrap, {
          "data-test-id": "WhyBuyTravIns-ShieldWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "286px",
            height: "320px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg",
            "data-test-id": "WhyBuyTravIns-ImageComponent"
          })
        })]
      })
    })
  });
};

/* harmony default export */ const WhyBuyTravIns_WhyBuyTravIns = (WhyBuyTravIns);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx






















/***/ }),

/***/ 7928:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bk": () => (/* reexport */ InsuranceGiLandingPageMainWrapper),
  "pB": () => (/* reexport */ InsuranceLanding_InsuranceLanding),
  "x1": () => (/* reexport */ InsuranceLandingPageMainWrapper)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/PreloadImages.tsx




const PreloadImages = pageProps => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    "data-test-id": "PreloadImages-Head",
    children: [pageProps?.data?.claimSettlementText?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.claimSettlementText.icon}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), pageProps?.data?.travelSearchBanner?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.travelSearchBanner.icon}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), pageProps?.data?.secureTravData?.[0]?.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.secureTravData[0].travImg}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), pageProps?.data?.secureTravData?.[1]?.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: `${pageProps.data.secureTravData?.[1].travImg}`,
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      href: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg",
      as: "image",
      "data-test-id": "PreloadImages-link"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_PreloadImages = (PreloadImages);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx + 12 modules
var components = __webpack_require__(51066);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var static_components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-footer/dist/growth-dweb-footer.esm.js
var growth_dweb_footer_esm = __webpack_require__(26147);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLanding.style.ts



const InsuranceLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceLandingPageMainWrapper",
  componentId: "sc-1l4dje5-0"
})(["background-image:linear-gradient(rgba(5,19,34,1),rgba(21,69,124,1));background-size:100% 990px;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;@media ", "{background-image:none;padding-top:0px;}"], isomorphic_utils_src.deviceType.mobile);
const InsuranceGiLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__InsuranceGiLandingPageMainWrapper",
  componentId: "sc-1l4dje5-1"
})(["padding-top:16px;position:relative;z-index:2;&:after{content:\"\";position:absolute;top:240px;width:100%;left:0;background-color:#eff3f8;height:1200px;z-index:1;}:before{content:\"\";position:absolute;top:0;width:100%;left:0;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831888_401a4765df.png\");background-size:100% 382px;background-repeat:no-repeat;height:382px;z-index:2;}@media ", "{background-image:none;padding-top:0px;&:after{background-color:transparent;}}"], isomorphic_utils_src.deviceType.mobile);
const PersuasionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__PersuasionWrapper",
  componentId: "sc-1l4dje5-2"
})(["width:1200px;margin:0 auto;", "{max-width:60%;}"], static_components/* H3TagStyle */.KO);
const LandingPageRightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__LandingPageRightWrapper",
  componentId: "sc-1l4dje5-3"
})(["display:flex;flex-direction:column;gap:24px;"]);
const GiFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceLandingstyle__GiFooterWrap",
  componentId: "sc-1l4dje5-4"
})(["width:100%;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceBottomComp.tsx



 // Dynamically import SeoContent with server-side rendering disabled

const SeoContent = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51066)).then(mod => mod.SeoContent), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(51066)]
  }
});






const data = [{
  title: "Popular Flight Sectors",
  links: [{
    text: "Kolkata to Delhi Flight",
    url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/"
  }, {
    text: "Hyderabad to Delhi Flight",
    url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/"
  }]
}];

const InsuranceBottomComp = ({
  bottomCompData,
  footerInfo
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    claimYourInsurance,
    testimonials,
    faq,
    customNumbers,
    crossSell,
    offers,
    seoContent
  } = bottomCompData; //TODO: check for if(footerInfo) and remove optional chaining to improve performance

  const footerLinks = footerInfo?.filter(data => data.type === "section")?.map((item, index) => ({
    id: index.toString(),
    label: item.title || "",
    listPoints: item?.links?.map((link, i) => ({
      id: i.toString(),
      label: link.title || "",
      link: link.url || ""
    })) ?? [],
    icon: ""
  })) ?? [];
  const footerHeading = footerInfo?.find(data => data.type === "rich-text");
  const footerCopyrightData = footerInfo?.find(data => data.type === "footnote");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [customNumbers && /*#__PURE__*/(0,jsx_runtime.jsx)(components.InsuranceStats, {
      data: customNumbers,
      "data-test-id": "InsuranceBottomComp-InsuranceStats"
    }), offers && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ExclusiveOffers, {
      data: offers,
      "data-test-id": "InsuranceBottomComp-ExclusiveOffers"
    }), TravelInsData && /*#__PURE__*/(0,jsx_runtime.jsx)(components.WhyBuyTravIns, {
      title: TravelInsData.title,
      info: TravelInsData.info,
      data: TravelInsData.featureCard,
      "data-test-id": "InsuranceBottomComp-WhyBuyTravIns"
    }), safeSecureTravel && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SafenSecureTrav, {
      data: safeSecureTravel.safeTravCrd,
      title: safeSecureTravel.title,
      "data-test-id": "InsuranceBottomComp-SafenSecureTrav"
    }), whatsCovered && /*#__PURE__*/(0,jsx_runtime.jsx)(components.WhatsCovered, {
      data: whatsCovered.travCrd,
      title: whatsCovered.title,
      info: whatsCovered.info,
      "data-test-id": "InsuranceBottomComp-WhatsCovered"
    }), claimYourInsurance && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ClaimYourInsurance, {
      title: claimYourInsurance.title,
      info: claimYourInsurance.info,
      data: claimYourInsurance.claimData,
      "data-test-id": "InsuranceBottomComp-ClaimYourInsurance"
    }), device == "lg" && crossSell && /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionWrapper, {
      "data-test-id": "InsuranceBottomComp-PersuasionWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.PersuasionBannerInsurance, {
        crossSell: crossSell,
        btnHandler: () => {
          context === isomorphic_utils_src.PARTNER.GI ? window.open("https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop", "_blank") : window.open("https://www.makemytrip.com/forex", "_blank");
        } // info={persuasionBannerMob.info}
        ,
        "data-test-id": "InsuranceBottomComp-PersuasionBannerInsurance"
      })
    }), testimonials && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingTestimonials, {
      customTitle: testimonials?.title,
      test: testimonials?.testimonialData,
      "data-test-id": "InsuranceBottomComp-LandingTestimonials"
    }), seoContent && /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContent, {
      seoContent: seoContent,
      "data-test-id": "InsuranceBottomComp-SeoContent"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingFaq, {
      customTitle: faq?.title,
      faq: faq?.faqList,
      "data-test-id": "InsuranceBottomComp-LandingFaq"
    }), bottomCompData?.interlinkingBlock && /*#__PURE__*/(0,jsx_runtime.jsx)(components.InterlinkingBlock, {
      interlinkingBlock: bottomCompData?.interlinkingBlock,
      "data-test-id": "InsuranceBottomComp-InterlinkingBlock"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.Breadcrumb, {
      hostname: context === isomorphic_utils_src.PARTNER.GI ? "www.goibibo.com" : "www.makemytrip.com",
      "data-test-id": "InsuranceBottomComp-Breadcrumb"
    }), context === isomorphic_utils_src.PARTNER.GI && device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(GiFooterWrap, {
      "data-test-id": "InsuranceBottomComp-GiFooterWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(growth_dweb_footer_esm/* Footer */.$, {
        data: data,
        adobe: "",
        "data-test-id": "InsuranceBottomComp-Footer"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingFooter, {
      playStoreImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png",
      appStoreImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png",
      facebookImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
      linkedInImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
      twitterImgURI: "https://tripmoneycmsimgak.mmtcdn.com/img/twitter_Icon_760f145ad2.png",
      footerData: footerLinks,
      footerHeading: footerHeading,
      footerCopyrightData: footerCopyrightData,
      "data-test-id": "InsuranceBottomComp-LandingFooter"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceBottomComp = (InsuranceBottomComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(91908);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 4 modules
var utils = __webpack_require__(64264);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx + 1 modules
var TravellingToShimmer = __webpack_require__(62915);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLandingShimmer.tsx



 //import Header from 'gi-happy-header/ssr/header';
//import { Header  } from 'pwa-mmt-ui-header/ssr/header';




const InsuranceLandingShimmer = () => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* DesktopLayout */.S_, {
      alignCenter: true,
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components/* FlexComp */.bA, {
          gap: "8px",
          flexDirection: "column",
          "data-test-id": "InsuranceLandingShimmer-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
            height: "55px",
            width: device == "lg" ? "375px" : "100px",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
            height: "55px",
            width: "100%",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "20px" : "10px",
          width: device == "lg" ? "248px" : "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* Shimmer */.qm, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToShimmer/* default */.Z, {
        "data-test-id": "InsuranceLandingShimmer-TravellingToShimmer"
      }),
      "data-test-id": "InsuranceLandingShimmer-DesktopLayout"
    })
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceLandingShimmer = (InsuranceLandingShimmer);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/InsuranceLanding/InsuranceLanding.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import "pwa-mmt-ui-header/ssr/header.css";

















const analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceLanding = ({
  data,
  setActiveModal
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const experiment = (0,react.useContext)(src/* ExperimentTrackingString */.Mq) || "";
  if (!data) return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLandingShimmer, {
    "data-test-id": "InsuranceLanding-InsuranceLandingShimmer"
  });
  const {
    title,
    claimSettlementText,
    secureTravData,
    travellingTo,
    calendarDatesLimit,
    upcomingTrip,
    upcomingTripsV2,
    errorFields,
    footer,
    travelSearchBanner,
    nextPageRoute,
    analytics: pageAnalytics
  } = data || {};
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isLoggedIn,
    1: setIsLoggedIn
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = queryParams.get("countries");
    const selectedCountryCodes = selectedCountries?.split(",");
    const segmentType = queryParams.get("segment");
    const countryData = travellingTo?.travelSearchForm?.regionCountryList?.value || [];
    let totalCountryData = countryData?.map(data => {
      if (selectedCountryCodes?.includes(data.code)) {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, data);
    });
    const selectedCountry = totalCountryData?.filter(item => item.isSelected);

    if (countryData?.length) {
      localStorage.setItem("TRAVEL_INSURANCE_COUNTRIES", JSON.stringify(countryData));
    }

    if (data) {
      if (pageAnalytics?.pageLoad) {
        analytics?.trackRawPageLoadEvent(pageAnalytics.pageLoad);
      } else {
        analytics?.trackPageLoadEvent({
          pageName: "LANDING",
          experiment
        });
      }

      (0,XDMAnalytics.initializePageTracking)({
        page_context: {
          page_name: "landing",
          page_type: "landing",
          funnel_step: "landing",
          subpage_name: `seo_landing${data?.travelCountry ? `:${data?.travelCountry}` : ""}`
        }
      }, {
        countries: selectedCountry ? selectedCountry : [],
        journeyType: segmentType || "",
        travellers: parseInt(queryParams.get("travellers") || "1"),
        fromDateTime: queryParams.get("startDate") ? parseInt(queryParams.get("startDate") || "0") : 0,
        toDateTime: queryParams.get("endDate") ? parseInt(queryParams.get("endDate") || "0") : 0
      });
    }
  }, [data]);
  (0,react.useEffect)(() => {
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");
    setIsLoggedIn(!!authCookie);
  }, []);

  const goToMyOrders = () => {
    analytics?.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "my_orders_clicked"
      }
    });
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      navigation/* navigationActionsSeo.navigateToOrderListing */.Ro.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_PreloadImages, {
      data: data,
      "data-test-id": "InsuranceLanding-PreloadImages"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* DesktopLayout */.S_, {
      landingPageProp: true,
      title: title,
      height: device == "lg" ? "720px" : "",
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      goToMyOrders: goToMyOrders,
      showMyOrders: isLoggedIn,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components/* FlexComp */.bA, {
          margin: device == "sm" ? "0 0 0px" : context ? "-30px 0 0" : "",
          alignItems: "center",
          gap: "6px",
          "data-test-id": "InsuranceLanding-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* ImageComponent */.cu, {
            width: "12px",
            height: "16px",
            src: claimSettlementText?.icon,
            loading: "eager",
            "data-test-id": "InsuranceLanding-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* SpanTag */.pF, {
            fontSize: "xs",
            fontWeight: "bold",
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "InsuranceLanding-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
              value: claimSettlementText?.title,
              "data-test-id": "InsuranceLanding-FormattedText"
            })
          })]
        }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        }) : ""]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingPageRightWrapper, {
        "data-test-id": "InsuranceLanding-LandingPageRightWrapper",
        children: [upcomingTripsV2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.DomesticTrip, {
          title: upcomingTripsV2?.title,
          trips: upcomingTripsV2?.trips,
          "data-test-id": "InsuranceLanding-DomesticTrip"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.TravellingTo, {
          travelSearchBanner: travelSearchBanner,
          travellingToSection: travellingTo,
          upcomingTrip: upcomingTrip,
          calendarDatesLimit: calendarDatesLimit,
          nextPageRoute: nextPageRoute,
          errorFields: errorFields,
          countryCodes: data.countryCode,
          setLoginModal: setActiveModal,
          "data-test-id": "InsuranceLanding-TravellingTo"
        }), device != "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        })]
      }),
      bottomComp: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceBottomComp, {
        bottomCompData: data,
        footerInfo: footer,
        "data-test-id": "InsuranceLanding-InsuranceBottomComp"
      }),
      "data-test-id": "InsuranceLanding-DesktopLayout"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceLanding = (InsuranceLanding);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/pages/index.tsx



/***/ })

}]);